import React from 'react';
import PropTypes from 'prop-types';
import DayMonthYearInputContainer from '../../../redux/containers/DayMonthYearInputContainer';
import DayMonthYearErrorContainer from '../../../redux/containers/DayMonthYearErrorContainer';
import './DayMonthYear.scss';
import ValidRanges from '../../../common/validation/ValidRanges';

const DayMonthYear = (props) => {
  const { name, ...rest } = props;
  const { label, autotestClass, required } = rest;
  return (
    <div className="form-input-container relative">
      <label htmlFor={name}>{label}</label>
      {required && <span className="form-required-text">*</span>}
      <div className="day-month-year-container">
        <div className="day-month-year-daymonth">
          <DayMonthYearInputContainer
            className={`${autotestClass}-day`}
            name={`${name}Day`}
            placeholder="DD"
            min={ValidRanges.MIN_DAY}
            max={ValidRanges.MAX_DAY}
            maxLength={2}
            {...rest}
          />
        </div>
        <div className="day-month-year-daymonth">
          <DayMonthYearInputContainer
            className={`${autotestClass}-month`}
            name={`${name}Month`}
            placeholder="MM"
            min={ValidRanges.MIN_MONTH}
            max={ValidRanges.MAX_MONTH}
            maxLength={2}
            {...rest}
          />
        </div>
        <div className="day-month-year-year">
          <DayMonthYearInputContainer
            className={`${autotestClass}-year`}
            name={`${name}Year`}
            placeholder="YYYY"
            min={ValidRanges.MIN_YEAR}
            max={ValidRanges.MAX_YEAR}
            maxLength={4}
            {...rest}
          />
        </div>
      </div>
      <div className="day-month-year-error-container">
        <div>
          <DayMonthYearErrorContainer
            name={`${name}Day`}
            {...rest}
          />
        </div>
        <div>
          <DayMonthYearErrorContainer
            name={`${name}Month`}
            {...rest}
          />
        </div>
        <div>
          <DayMonthYearErrorContainer
            name={`${name}Year`}
            {...rest}
          />
        </div>
      </div>
    </div>);
};

DayMonthYear.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autotestClass: PropTypes.string
};

export default DayMonthYear;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/DayMonthYear/DayMonthYear.js
 **/